import React, { Component } from 'react';

import { ROUTER_CONSTANT } from '../../../constants/routerConstant';

class Remark extends Component {
    componentDidMount() {
        this._isMounted = true;

        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_REMARK_ROOT_CAUSE);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return <></>;
    }
}

export default Remark;